window.onload = function () {
  scroll_effect();

  $(window).scroll(function () {
    scroll_effect();
  });

  function scroll_effect() {
    $('.aw-headline').each(function () {
      var elemPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height() - 250;
      if (scroll > elemPos - windowHeight) {
        $(this).addClass('effect-headline-scroll');
      }
    });
    $('.fade-in').each(function () {
      var elemPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height() - 150;
      if (scroll > elemPos - windowHeight) {
        $(this).addClass('active');
      }
    });
  }
};

$(document).ready(function(){
  let longHtml = `
      <div class="aw-shoplist-blog__header_en">
          <h2 class="aw-shoplist-blog__header__headline2 jp-mode">
            <p class="aw-shoplist-blog__header__headline2--en_text">
            Overseas shop list
            </p>
            <p class="aw-shoplist-blog__header__headline2--jp_text">
              海外のショップリスト
            </p>
          </h2>
          <h2 class="aw-shoplist-blog__header__headline2 en-mode">
            <p class="aw-shoplist-blog__header__headline2--en_text">
            Overseas shop list
            </p>
          </h2>
        </div>
  `;

  $("#aw-shoplist-blog_table_90787217640").before(longHtml);
});